/**
 *
 * Attaches change event listener to color dropdown, firing necessary updates
 * (typically attached to '.product-option--color .product-option__select')
 * @module modules/colorChange
 */

import $ from 'jquery';
import redirectHref from '../lib/redirect-href';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

const { loadColorMarkup } = require('../../../../src/scripts/modules/preload-markup');

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'colorChange';
export const USE_AJAX_ATTR = 'useAjax';

function loadMarkup(result, code, chosen, size) {
  if (result.success) {
    // js-modal moves this out of the markup that gets replaced
    $('#product-added-confirmation').remove();
    $('#detailsMarkup').html(result.detailsMarkup);
    $('#accordionMarkup').html(result.accordionMarkup);
    if (result.bestSellerBadge) {
      $('#js-bs-badge-container').html(result.bestSellerBadge);
    } else {
      $('#js-bs-badge-container').empty();
    }
    $('.js-counter').counter();
    // reload similar items
    const $similarItems = $('#similarItemsMarkup');
    if ($similarItems.length) {
      if (result.similarItemsMarkup) {
        $similarItems
          .html(result.similarItemsMarkup)
          .find('.js-horizontal-scroll')
          .horizontalScroll();
      } else {
        $similarItems.html('');
      }
    }

    const $fitPredictorRoot = $('.fp-root');
    const allSizes = [];
    const availableSizes = [];
    let fpSize = null;

    $('#size option').each(function optionFP() {
      const thisSize = $(this).val();
      if (thisSize) {
        allSizes.push(thisSize);
        const isAvailable = $(this).attr('data-oos') !== 'true';
        if (isAvailable) {
          availableSizes.push(thisSize);
          if (thisSize === size) {
            if ($fitPredictorRoot.length) {
              fpSize = size;
            }
          }
        }
      }
    });

    if ($fitPredictorRoot.length) {
      window.ssp('set', 'product', {
        productId: $fitPredictorRoot.data('productId'),
        size: fpSize,
        color: $(chosen).data('colorName'),
        sizes: allSizes,
        availableSizes,
        variantId: code,
      });
      window.ssp('start', 'fitpredictor');
    }

    window.initPDPJs(code);

    const $completeTheLook = $('#completeTheLookMarkup');
    if ($completeTheLook.length) {
      if (result.completeTheLookMarkup) {
        $completeTheLook
          .html(result.completeTheLookMarkup)
          .find('.js-horizontal-scroll')
          .horizontalScroll();
      } else {
        $completeTheLook.html('');
      }
    }

    // page track and update history state
    window.rcProps.pdp.ajaxedColorChange = true;
    window.rcProps.pdp.newReferrer = window.location.href;
    window.insertPageTrackForMobileWithData({
      productCode: code,
    });
    const url = new URL($(chosen).data('href'), window.location.origin);
    url.searchParams.set('sizeSelected', 'true');
    window.history.replaceState({
      code,
      colorClicked: true,
    }, result.title, url);
    document.title = result.title;
  } else {
    $('.js-price-range').show();
    $('.js-price-single').hide();
    redirectHref(chosen);
    const url = new URL(window.location.href);
    url.searchParams.delete('sizeSelected');
    window.history.replaceState({}, document.title, url.toString());
  }
  if (typeof window.getPDPCustomerReviewsHTML === 'function') {
    window.getPDPCustomerReviewsHTML(code, undefined, 1);
  }
  // favorite status has been changed in this window after markup was loaded
  const $heartButton = $('#main-content .js-fav-button');
  const productHearts = window.productHearts || {};
  if (Object.prototype.hasOwnProperty.call(productHearts, code) && window.rcProps
      && window.rcProps.favoriteActiveClass && $heartButton.length) {
    if (window.productHearts[code]) {
      $heartButton.addClass(window.rcProps.favoriteActiveClass);
      $heartButton.attr('aria-checked', true);
    } else {
      $heartButton.removeClass(window.rcProps.favoriteActiveClass);
      $heartButton.attr('aria-checked', false);
    }
  }
}

/**
 * List of all updates made on change.
 * @param {HTMLElement} evt - The select dropdown we're attaching to
 */
export const runUpdates = ({ currentTarget }) => {
  // whether input or select, find the chosen element
  const { options, selectedIndex } = currentTarget;
  const chosen = options ? options[selectedIndex] : currentTarget;
  const code = $(chosen).data('code');
  const useAjax = $(chosen).data(USE_AJAX_ATTR);
  const sizeOption = $('#size-products option:selected');

  let size = $('#size').val();
  if ((size === undefined || typeof size === 'undefined') && sizeOption) {
    size = sizeOption.val();
  }
  if (size && typeof size !== 'undefined') {
    let url = $(chosen).data('href');
    url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({ size });
    $(chosen).attr('data-href', url);
    if (sizeOption && sizeOption.data('reload') === true) {
      url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({ sizeSelected: true });
      document.location.href = url;
      return;
    }
  }

  if (typeof useAjax !== 'undefined' && !useAjax) {  // Only redirect if defined as `false`
    redirectHref(chosen);
  } else {
    window.rcProps.colorSwatchMarkup = window.rcProps.colorSwatchMarkup || {};

    let colorData = window.rcProps.colorSwatchMarkup[code];
    // check for required items that are used in `loadMarkup`, especially if there's a failure in
    // the JS that stores pieces of data for the initial product fails
    if (colorData
        && typeof colorData.then !== 'function'
        && (!('success' in colorData)
        || !('title' in colorData)
        || !('detailsMarkup' in colorData)
        || !('similarItemsMarkup' in colorData)
        // 'bestSellerBadge' is also checked and used but only if there's a badge
        || !('accordionMarkup' in colorData)
        || !('completeTheLookMarkup' in colorData))) {
      colorData = null;
    }
    // it's a promise currently being loaded, just execute when it finishes
    if (colorData) {
      if (typeof colorData.then === 'function') {
        colorData.then(() => {
          loadMarkup(window.rcProps.colorSwatchMarkup[code], code, chosen, size);
        });
      } else {
        loadMarkup(colorData, code, chosen, size);
      }
    } else {
      loadColorMarkup([code]).then(() => {
        loadMarkup(window.rcProps.colorSwatchMarkup[code], code, chosen, size);
      });
    }
  }
};

/**
 * Attaches change event to select dropdown.
 * @private
 * @param {HTMLElement} dropdown - The select dropdown
 */
const attachChangeListener = dropdown => dropdown.change(evt => runUpdates(evt));

/**
 * Initializes color dropdown changes.
 * @param {HTMLElement} el - The select dropdown we're attaching to
 */
export default function colorChange(el) {
  const dropdown = $(el);

  attachChangeListener(dropdown);
}

registerJQueryPlugin(PLUGIN_NAME, colorChange);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-color-change.js